import { clearPhone } from '../../../utils/phone/clearPhone';

export const preparePhone = (phone: string): string => `+${clearPhone(phone)}`;
